exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-select[data-v-480081d1]{display:inline-block;text-align:center;cursor:pointer}.file-select .file-select-input[data-v-480081d1]{display:none}", ""]);

// exports
